// formato de las fechas y tiempos de el datetimepicker de la libreria NgPickDateTime
export const MY_NATIVE_FORMATS = {
    fullPickerInput: { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' },
    datePickerInput: { year: 'numeric', month: 'numeric', day: 'numeric' },
    timePickerInput: { hour: 'numeric', minute: 'numeric' },
    monthYearLabel: { year: 'numeric', month: 'numeric' },
    dateA11yLabel: { year: 'numeric', month: 'numeric', day: 'numeric' },
    monthYearA11yLabel: { year: 'numeric', month: 'numeric' },
};
// variables de los labels por defecto de los datetimepicker de la libreria NgPickDateTime
export const DefaultIntl = {
    /** Una etiqueta para el segundo botón hacia arriba (utilizado por los lectores de pantalla). */
    upSecondLabel: 'Agrega un segundo',
    /** Una etiqueta para el segundo botón hacia abajo (utilizado por los lectores de pantalla). */
    downSecondLabel: 'Menos un segundo',

    /** Una etiqueta para el botón de subir el minuto (utilizado por los lectores de pantalla). */
    upMinuteLabel: 'Agrega un minuto',
    /** Una etiqueta para el botón de reducción de minutos (utilizado por los lectores de pantalla). */
    downMinuteLabel: 'Menos un minuto',

    /** Una etiqueta para el botón de la hora hacia arriba (utilizada por los lectores de pantalla). */
    upHourLabel: 'Agrega una hora',

    /** Una etiqueta para el botón de la hora de abajo (utilizada por los lectores de pantalla). */
    downHourLabel: 'Menos una hora',

    /** Una etiqueta para el botón del mes anterior (utilizado por los lectores de pantalla). */
    prevMonthLabel: 'Mes anterior',

    /** Una etiqueta para el botón del mes siguiente (utilizado por lectores de pantalla). */
    nextMonthLabel: 'Próximo mes',

    /** Una etiqueta para el botón del año anterior (utilizado por los lectores de pantalla). */
    prevYearLabel: 'Año anterior',

    /** Una etiqueta para el botón del próximo año (utilizada por los lectores de pantalla). */
    nextYearLabel: 'Próximo año',

    /** Una etiqueta para el botón "cambiar a la vista de mes" (utilizado por los lectores de pantalla). */
    switchToMonthViewLabel: 'Cambiar a vista de mes',
    /** Una etiqueta para el botón "cambiar a vista de año" (utilizado por los lectores de pantalla). */
    switchToYearViewLabel: 'Cambiar a vista de año',

    /** Una etiqueta para el botón Cancelar */
    cancelBtnLabel: 'Cerrar',
    /** Una etiqueta para el botón de ajuste */
    setBtnLabel: 'Confirmar',

    /** Una etiqueta para el rango "de" en la información del selector */
    rangeFromLabel: 'desde',
    /** Una etiqueta para el rango "a" en la información del selector */
    rangeToLabel: 'hasta',
};



// WEBPACK FOOTER //
// ./src/app/shared/util/config-default-datetimepicker.ts